import {createI18n} from "vue-i18n";
import messages from "@intlify/unplugin-vue-i18n/messages";
import {watch} from "vue";
// Translations provided by Vuetify
import {en, it} from 'vuetify/locale';

export const defaultLocale = "it";

//integrate translations provided by Vuetify (our jsons can eventually override them)
messages.en.$vuetify = {...en, ...messages.en.$vuetify};
messages.it.$vuetify = {...it, ...messages.it.$vuetify};

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  availableLocales: [defaultLocale, "en"],
  messages: messages,
  warnHtmlInMessage: false,
  warnHtmlMessage: false
});

watch(i18n.global.locale, newValue =>
  document.querySelector("html").setAttribute("lang", newValue)
);
